import { Button, Col, Divider, Popconfirm, Row, Typography } from 'antd'
import { durationInWords, formatDateTime, parseDateTime } from '../../util/dateTimeUtil'

import MessageModal from './MessageModal'
import Messages from '../common/Messages'
import Section from '../common/Section'
import _ from 'lodash'
import axios from '../../axios/axios'
import { isPast } from '../../util/serverTimeUtil'
import { notifyError } from '../../util/notifyUtil'
import useMessages from '../../hooks/api/useMessages'
import { useState } from 'react'

const { Paragraph } = Typography

const colProps = {
  style: {
    padding: '1em',
  },
}

const MessagesPage = () => {
  const [state, setState] = useState(0)
  const { messages } = useMessages(state)
  const [message, setMessage] = useState()
  const [modalVisible, setModalVisible] = useState(false)

  const handleAdd = () => {
    setMessage(null)
    setModalVisible(true)
  }

  const handleEdit = (message) => {
    setMessage(message)
    setModalVisible(true)
  }

  const handleDelete = async (message) => {
    try {
      await axios.delete(`/admin/message/${message.id}`)
      setState((prev) => prev + 1)
      window.dispatchEvent(new Event('htc-messages-reload'))
    } catch (e) {
      notifyError('message-error', e)
    }
  }

  const handleSave = async (message) => {
    try {
      let { id, expires } = message
      message.visible = true
      expires = new Date(expires).toISOString()
      message = { ...message, expires }
      const { data: updated } = id
        ? await axios.put('/admin/message', message)
        : await axios.post('/admin/message', message)
      const i = _.findIndex(messages, { id: updated.id })
      const newMessages = [...messages]
      if (_.isNil(i) || i === -1) {
        newMessages.push(updated)
      } else {
        newMessages.splice(i, 1, updated)
      }
      setModalVisible(false)
      setState((prev) => prev + 1)
      window.dispatchEvent(new Event('htc-messages-reload'))
    } catch (e) {
      notifyError('message-error', e)
    }
  }

  const handleCancel = () => {
    setModalVisible(false)
  }

  return (
    <>
      <MessageModal messageToEdit={message} onOk={handleSave} onCancel={handleCancel} visible={modalVisible} />

      <Section title="Messages" />
      <Paragraph>
        Configure messages that will appear at the top of the home page. Messages are only visible there if they're
        enabled and have an expiry date in the future. Currently visible messages appear at the top of the list below.
      </Paragraph>
      <Paragraph>
        <Button onClick={handleAdd} type="primary">
          Add a new message
        </Button>
      </Paragraph>
      <Row>
        <Col {...colProps} xs={24}>
          <Messages
            forceUpdate={Math.random()}
            adminMode
            showAll
            visibleFirst
            extraContentProps={(message) => ({
              style: {
                marginBottom: '0.3em',
              },
            })}
            extraContent={(message) => (
              <div>
                <Divider />
                <Row justify="space-between">
                  <Col flex={1}>
                    <Button onClick={() => handleEdit(message)} type="link" style={{ padding: 0 }}>
                      Edit
                    </Button>
                    <Popconfirm
                      title={
                        <div style={{ paddingRight: '1.5em' }}>
                          <h3>Confirm delete</h3>
                          <div>Are you sure you want to delete this message?</div>
                        </div>
                      }
                      icon={null}
                      okType="primary"
                      onConfirm={() => handleDelete(message)}
                      okText="Delete"
                      cancelText="Cancel"
                      cancelButtonProps={{ type: 'link' }}
                    >
                      <Button type="link">Delete</Button>
                    </Popconfirm>
                    {!message.visible ? (
                      'Message is disabled.'
                    ) : (
                      <>
                        {isPast(parseDateTime(message.expires)) ? (
                          'Expired'
                        ) : (
                          <>
                            <span style={{ margin: '1em', color: '#000', backgroundColor: 'yellow', padding: '0.4em' }}>
                              Currently visible
                            </span>{' '}
                            Expires
                          </>
                        )}{' '}
                        {durationInWords(message.expires, true)} ({formatDateTime(message.expires, 'EEE MMM dd hh:mma')}
                        )
                      </>
                    )}
                  </Col>
                </Row>
              </div>
            )}
          />
        </Col>
      </Row>
    </>
  )
}

export default MessagesPage
